import { Component, Input } from "@angular/core";

@Component({
    selector: 'tidy-drop-down-menu-item',
    template: `<button mat-menu-item>
                @if (icon) {
                  <mat-icon>{{icon}}</mat-icon>
                }
                <ng-content></ng-content>
              </button>
              `,
    standalone: false
})
export class DropDownMenuItem {
  @Input() icon;

}
